import { Base, PageObject } from '@testsigmainc/models';
import { deserialize, serializable } from 'serializr';

export class DisabledTestCase extends Base implements PageObject {
  @serializable
  public id: number;
  @serializable
  public executionId: number;
  @serializable
  public suiteId: number;
  @serializable
  public testCaseId: number;
  @serializable
  public suiteTestCaseMappingId: number;
  @serializable
  public isDeleted: boolean = false;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(DisabledTestCase, input));
  }
}
